import { statsData } from '@/mocks/homeData';
import { StatCard } from '@/components/base/Card';

export default function StatsSection() {
  return (
    <section className="py-16 md:py-20 gold-gradient-bg">
      <div className="container-custom">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-10">
          {statsData.map((stat) => (
            <StatCard
              key={stat.label}
              value={stat.value}
              suffix={stat.suffix}
              label={stat.label}
            />
          ))}
        </div>
      </div>
    </section>
  );
}